import axios from 'axios';
import Button from 'blocks/Button';
import Row from 'blocks/Row';
import EmptyBox from 'components/EmptyBox';
import Modal from 'components/Modal';
import Pager from 'components/Pager';
import Table from 'components/Table';
import Paths from 'helper/paths';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import urls from 'utils/urls';
import { ContentProps } from './merchantsModal.interface';
import * as S from './merchantsModal.styles';

const Content = ({ open, closeModal, id }: ContentProps) => {
  const { t } = useTranslation();
  const [merchants, setMerchants] = useState<any[]>([]);
  const navigate = useNavigate();
  const [pageData, setPageData] = useState({
    count: 0,
    totalPage: 0,
    page: 0,
  });
  useEffect(() => {
    getMerchants(pageData.page);
  }, [pageData.page]);

  const getMerchants = async (page, query?: string) => {
    let params = `?page=${page}` + (query || '');

    const res = await axios.get(urls.merchant(id) + params);

    setMerchants(res.data.response.data);
    setPageData({
      totalPage: res.data.response.totalPages,
      page: res.data.response.currentPage,
      count: res.data.response.totalItems,
    });
  };
  const next = (): void => setPageData({ ...pageData, page: pageData.page + 1 });

  const prev = (): void => {
    if (pageData.page === 0) return;

    setPageData({ ...pageData, page: pageData.page - 1 });
  };

  return (
    <S.MerchantModal>
      {merchants.length ? (
        <>
          <S.ParentTable>
            <Table
              name="merchants"
              head={[{ text: t('pages.services.Products.sections.modals.sections.headers.name') }, { text: '' }]}
              rows={merchants.map((merchant) => [
                { content: merchant.name },

                {
                  content: (
                    <Row align="center" justify="center">
                      <Button
                        color="info"
                        styleType="text-button"
                        onClick={() => {
                          navigate(Paths.Services.Card().route(id?.toString() || ''), { state: merchant.id });
                        }}
                      >
                        {t('pages.services.Products.sections.modals.sections.headers.inquiry')}
                      </Button>
                    </Row>
                  ),
                },
              ])}
            />
          </S.ParentTable>

          <Pager total={pageData.count} page={pageData.page} next={next} prev={prev} />
        </>
      ) : (
        <EmptyBox boxed title={t('pages.services.Products.sections.emptyText')} />
      )}
    </S.MerchantModal>
  );
};

interface State {
  open: boolean;
  id: any;
}

interface Props {
  ref: any;
}

class MerchantModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      id: null,
    };
  }

  openModal = (id: any): void => this.setState({ open: true, id });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <Modal open={this.state.open} onClose={this.closeModal}>
        {this.state.id ? (
          <Content {...this.props} open={this.state.open} closeModal={this.closeModal} id={this.state.id} />
        ) : null}
      </Modal>
    );
  }
}

export default MerchantModal;
